const prodDomains = ['datayaki.com', 'www.datayaki.com', 'data.yaki.app', 'datayaki.web.app'];
const localhostDomains = ['localhost', '127.0.0.1', '.local'];

export function isProd() {
  return prodDomains.includes(window.location.hostname.toLowerCase());
}

export function isLocalhost() {
  return localhostDomains.some(d => window.location.hostname.toLowerCase().includes(d));
}